module.exports = __webpack_public_path__ + "static/img/smartAutomatedCard.c1258ce3.png";